import Image from 'next/image'
import { Star } from 'lucide-react'
import Subtitle from '@/components/ui/subtitle'
import { serviceTestimonials } from '@/constants/service-testimonials'

export default function ServiceTestimonials({ reviews = serviceTestimonials }) {
  return (
    <section
      aria-labelledby="service-testimonials-heading"
      className="bg-white text-ups-text"
    >
      <div className="mx-auto mb-14 max-w-3xl text-center">
        <Subtitle
          subtitle="Testimonials"
          center
          textColor="text-vblue3"
          gradientTextColor="from-vblue2 to-vcyan1"
        />
        <h2
          id="service-testimonials-heading"
          className="text-4xl font-bold !leading-[1.15] tracking-normal text-ups-text md:text-5xl"
        >
          What our clients and partners say
        </h2>
      </div>
      <div className="columns-1 gap-6 md:columns-2 xl:columns-3">
        {reviews.map((review) => (
          <figure
            key={review.name}
            className="mb-6 inline-block w-full break-inside-avoid rounded-3xl bg-slate-50 p-6 sm:p-8"
          >
            <div
              className="mb-5 flex gap-1 text-ups-primary"
              role="img"
              aria-label="5 out of 5 stars"
            >
              {Array.from({ length: 5 }, (_, index) => (
                <Star
                  key={index}
                  aria-hidden="true"
                  className="size-5 fill-current"
                />
              ))}
            </div>
            <blockquote className="text-base leading-8 text-black">
              <p>“{review.quote}”</p>
            </blockquote>
            <figcaption className="mt-6 flex items-center gap-4">
              {review.image ? (
                <Image
                  src={review.image}
                  alt=""
                  width={40}
                  height={40}
                  className="size-10 shrink-0 rounded-full object-cover"
                />
              ) : (
                <span
                  aria-hidden="true"
                  className="flex size-10 shrink-0 items-center justify-center rounded-full bg-slate-200 text-sm font-semibold text-slate-700"
                >
                  {review.name
                    .split(' ')
                    .slice(0, 2)
                    .map((part) => part[0])
                    .join('')}
                </span>
              )}
              <div>
                <p className="font-semibold text-black">{review.name}</p>
                {review.role && (
                  <p className="mt-1 text-sm text-slate-600">{review.role}</p>
                )}
              </div>
            </figcaption>
          </figure>
        ))}
      </div>
    </section>
  )
}
